/* RESPONSIBLE TEAM: team-phone */
import ApplicationAdapter from 'embercom/adapters/application';

export default class SettingsCallingAdapter extends ApplicationAdapter {
  pathForType() {
    return 'calling_settings';
  }
}
